import { useState } from 'react';
import { Form, Button } from 'react-bootstrap';
import Loader from './Loader';
import { useSubscribeNewsletterMutation } from '../slices/contactApiSlice';
import { toast } from 'react-toastify';

// variant: 'inline' (compact, no labels - used in the footer)
//          'stacked' (labeled fields - used on the commissions page)
const NewsletterSignup = ({ variant = 'inline' }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  const [subscribeNewsletter, { isLoading }] = useSubscribeNewsletterMutation();

  const submitHandler = async (e) => {
    e.preventDefault();
    try {
      const res = await subscribeNewsletter({ name, email }).unwrap();
      toast.success(res?.message || 'Subscribed');
      setName('');
      setEmail('');
    } catch (error) {
      toast.error(error?.data?.message || error.error);
    }
  };

  if (variant === 'stacked') {
    return (
      <Form onSubmit={submitHandler}>
        <Form.Group className="my-3" controlId="newsletterName">
          <Form.Label>Name</Form.Label>
          <Form.Control
            type="text"
            placeholder="Enter name"
            value={name}
            onChange={(e) => setName(e.target.value)}
          ></Form.Control>
        </Form.Group>
        <Form.Group className="my-3" controlId="newsletterEmail">
          <Form.Label>Email address</Form.Label>
          <Form.Control
            type="email"
            placeholder="Enter email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          ></Form.Control>
        </Form.Group>
        <Button
          type="submit"
          variant="primary"
          className="mt-2"
          disabled={isLoading}
        >
          Subscribe
        </Button>
        {isLoading && <Loader />}
      </Form>
    );
  }

  return (
    <Form onSubmit={submitHandler}>
      <Form.Control
        size="sm"
        type="text"
        placeholder="Name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        aria-label="Name"
        className="mb-2"
        style={{ fontSize: '0.8rem' }}
      />
      <Form.Control
        size="sm"
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        aria-label="Email address"
        className="mb-2"
        style={{ fontSize: '0.8rem' }}
      />
      <Button
        type="submit"
        variant="primary"
        size="sm"
        className="w-100"
        disabled={isLoading}
      >
        Subscribe
      </Button>
    </Form>
  );
};

export default NewsletterSignup;
